import { Controller } from 'stimulus';

class HeaderController extends Controller {
  connect() {
    this.delta = 0;
    this.lastScrollY = 0;
    this.lastScrollDirection = 'down';
    this.headerVisible = true;
  }

  onScroll() {
    const scrollDiff = window.scrollY - this.lastScrollY;
    const scrollDiffAbs = Math.abs(scrollDiff);

    // If scrolling up and the last scroll direction was down
    if (scrollDiff < 0 && this.lastScrollDirection === 'down') {
      this.lastScrollDirection = 'up';
      this.delta = 0;
    // If scroll down and the last scroll direction was up
    } else if (scrollDiff > 0 && this.lastScrollDirection === 'up') {
      this.lastScrollDirection = 'down';
      this.delta = 0;
    // Increment the delta, the user is scrolling in the same direction
    } else {
      this.delta += scrollDiffAbs;
    }

    // If the header is visible, but the user has scrolled down enough to hide it
    if (this.headerVisible && this.lastScrollDirection === 'down' && this.delta > 100) {
      this.hideHeader();
    // If the header is hidden, but the user has scrolled up
    } else if (!this.headerVisible && this.lastScrollDirection === 'up') {
      this.showHeader();
    }

    this.lastScrollY = window.scrollY;
  }

  showHeader() {
    this.headerVisible = true;
    this.element.style.opacity = 1;
    this.element.style.transform = 'translateY(0)';
    this.element.style.pointerEvents = 'auto';
  }

  hideHeader() {
    this.headerVisible = false;
    this.element.style.opacity = 0;
    this.element.style.transform = 'translateY(-10px)';
    this.element.style.pointerEvents = 'none';
  }
}

export default HeaderController;
